export default __webpack_public_path__ + "static/media/success.ce367f4d.svg";